import graphql__5d4b0b3284254aa6ddc4 from "./__generated__/AnswerPreviewRichText_answer.graphql.js";import { createFragmentContainer } from "react-relay";
import { graphql } from "react-relay";

import RichText from "../Utils/RichText";

const AnswerPreviewRichText = props => {
  return (
    <RichText
      className="form-answer-data-inner padding-sm bg-light"
      content={props.answer.content}
    />
  );
};

export default createFragmentContainer(AnswerPreviewRichText, {
  answer: graphql__5d4b0b3284254aa6ddc4
});
